import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { TournamentRound } from '../models/tournament-round';
import { map } from 'rxjs/operators';
import { TournamentRoundTeam } from '../models/tournament-round-team';
import { Playoff } from '../models/playoff';
import { TournamentGroup } from '../models/tournament-group';
import { applyGamesFilters, TournamentGamesFilters } from './tournament-api';
import { PaginatedResponse } from './paginated-response.interface';
import { Game } from '../models/game';

export interface TournamentRoundTeamsFilters {
  groupId?: number;
  divisionId?: number;
}

@Injectable({providedIn: 'root'})
export class TournamentRoundApi {
  constructor(
    private httpClient: HttpClient,
    private configService: ConfigService,
  ) {
  }

  async getById(tournamentRoundId: number): Promise<TournamentRound> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_round/${tournamentRoundId}/`).pipe(
      map(data => TournamentRound.toFront(data)),
    ).toPromise();
  }

  async getTeams(tournamentRoundId: number, filters?: TournamentRoundTeamsFilters): Promise<TournamentRoundTeam[]> {
    let params = new HttpParams();
    if (filters) {
      if (filters.divisionId) {
        params = params.set('division_id', filters.divisionId);
      }
      if (filters.groupId) {
        params = params.set('group_id', filters.groupId);
      }
    }
    return this.httpClient.get(
      `${this.configService.get('apiUrl')}/api/v1/tournament_round/${tournamentRoundId}/teams/`,
      {params}
    ).pipe(
      map(data => TournamentRoundTeam.toFront(data)),
    ).toPromise();
  }

  async getPlayoffs(tournamentRoundId: number): Promise<Playoff[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_round/${tournamentRoundId}/playoffs/`).pipe(
      map(data => Playoff.toFront(data)),
    ).toPromise();
  }

  async getGroups(tournamentRoundId: number): Promise<TournamentGroup[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_round/${tournamentRoundId}/groups/`).pipe(
      map(data => TournamentGroup.toFront(data)),
    ).toPromise();
  }

  async getGames(roundId: number, page: number, size: number, filters: TournamentGamesFilters): Promise<PaginatedResponse<Game[]>> {
    let params = new HttpParams().set('page', page.toString());
    if (size) {
      params = params.set('size', size.toString());
    }
    params = applyGamesFilters(filters, params);
    return this.httpClient.get(
      `${this.configService.get('apiUrl')}/api/v1/tournament_round/${roundId}/games/`,
      {params, observe: 'response'}
    ).pipe(
      map(result => ({
        total: +result.headers.get('X-Page-Count'),
        data: Game.toFront(result.body)
      }))
    ).toPromise();
  }}
